export default __webpack_public_path__ + "static/media/1.751be0f2.jpg";